import { useEffect, useState } from 'react'
import { ReportedIncome } from 'Components/ChildDetails/ReportedIncome'
import { sendGet } from 'hooks/use-fetch'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { ProgramVerification } from 'Components/Program/ProgramVerification'

export interface IncomeCardProps {
  childID: number
  readOnly: boolean
}

interface IncomeData {
  reportedIncomeID: number | null
  programVerificationIDs: number[]
}
export function IncomeCard (props: IncomeCardProps): JSX.Element {
  const [incomeData, setIncomeData] = useState<IncomeData | null>(null)

  useEffect(() => {
    async function fetchDataforFilter (): Promise<void> {
      const { response: sessions } = await sendGet(`/ReportedIncome/ChildIncomeData?childID=${props.childID}`, {})
      setIncomeData(sessions)
    }
    void fetchDataforFilter()
  }, [])

  if (incomeData === null) {
    return <CircularProgress />
  } else {
    return <Box className='CardDisplay' >
      <Typography variant='h6' sx={{ fontWeight: 'bold' }} gutterBottom>Income Details</Typography>
      <Stack direction='column' spacing={2}>
        <Stack direction='column'>
          <Typography>Reported Income:</Typography>
          <ReportedIncome id={incomeData.reportedIncomeID} childID={props.childID} canEdit={!props.readOnly} />
        </Stack>
        {incomeData.programVerificationIDs.map((id) => (
          <ProgramVerification verificationId={id.toString()} redirectText='Child Details' doNotDisplayAsCard={true} readOnly={props.readOnly } />
        ))}
      </Stack>
    </Box>
  }
}
